import React from 'react';
import PolBadge from "v4/components/ui/PolBadge/PolBadge";

export default function NotAllowed() {
    return <PolBadge status="error" text="rights_access_deny"/>
}
